// Cross-origin media (the CDN) does not send CORS headers, so a browser
// `fetch().blob()` is blocked. We route binary downloads through a same-origin
// reverse proxy (the Vite dev server in dev, nginx in production) which fetches
// the asset server-side (not CORS-bound) and streams it back. The proxy is
// locked to *.vizzly.net hosts, so it is not an open proxy.
//
// Shape: https://cdn-stg.vizzly.net/a/b.mp4 -> /__media/cdn-stg.vizzly.net/a/b.mp4
export function proxiedMediaUrl(url: string): string {
  try {
    const u = new URL(url);
    if (/^https?:$/.test(u.protocol) && /(^|\.)vizzly\.net$/i.test(u.hostname)) {
      return `/__media/${u.host}${u.pathname}${u.search}`;
    }
  } catch {
    /* not an absolute URL - use as-is */
  }
  return url;
}
